
import AnimatedSection from '../../../components/base/AnimatedSection';

const WA_CASO = "https://wa.me/5493415779623?text=Hola!%20Quiero%20reservar%20para%20ir%20a%20la%20Formaci%C3%B3n%20de%20Pergamino%20en%20La%20Usina%20Norte";

export default function PracticarEnVivo() {
  const items = [
    { icon: "ri-customer-service-2-line", title: "Respuestas a clientes", desc: "Y soporte." },
    { icon: "ri-article-line", title: "Textos de ventas", desc: "Y mensajes comerciales." },
    { icon: "ri-file-text-line", title: "Borradores de propuestas", desc: "Y presupuestos." },
    { icon: "ri-folder-3-line", title: "Organización de información", desc: "Y resumen de documentos." },
    { icon: "ri-lightbulb-line", title: "Ideas de contenido", desc: "Y piezas para redes." },
    { icon: "ri-git-branch-line", title: "Estructuras para procesos", desc: "Internos." },
  ];

  return (
    <section className="py-20 bg-gray-900 text-white">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto">
          <AnimatedSection animation="fadeUp">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-center">
              Qué vas a practicar en vivo
            </h2>
            <p className="text-xl text-gray-300 mb-12 text-center">
              Ejemplos de prácticas en clase.
            </p>
          </AnimatedSection>

          <div className="grid md:grid-cols-3 gap-6 mb-12">
            {items.map((item, index) => (
              <AnimatedSection key={item.title} animation="fadeUp" delay={index * 80}>
                <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10 h-full">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 rounded-lg mb-4">
                    <i className={`${item.icon} text-2xl text-white`} />
                  </div>
                  <h3 className="text-lg font-semibold mb-2">{item.title}</h3>
                  <p className="text-gray-400 text-sm">{item.desc}</p>
                </div>
              </AnimatedSection>
            ))}
          </div>

          <AnimatedSection animation="fadeUp" delay={100}>
            <div className="bg-teal-500/20 border border-teal-500/30 rounded-xl p-8 mb-8">
              <p className="text-xl text-center font-medium">
                Traé un caso real de tu actividad. Lo trabajás con guía.
              </p>
            </div>
          </AnimatedSection>

          <AnimatedSection animation="scaleUp" delay={200}>
            <div className="text-center">
              <a
                href={WA_CASO}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-8 py-4 bg-teal-500 text-white rounded-lg font-semibold text-lg hover:bg-teal-400 hover:scale-110 transition-all duration-300 whitespace-nowrap cursor-pointer hover:shadow-2xl hover:shadow-teal-500/50"
              >
                Quiero llevar mi caso
              </a>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
}
